// 定义每项运动分别有哪些概要字段显示
export const sportSummaryItems = {
  // 户外跑
  Run: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'FPRatio' },
    { key: 'AvgCadence' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Adjusted_Pace' },
    { key: 'Body_Temperature' }
  ],
  // 体能测试
  Test: [{ key: 'TestThresholdPace' }, { key: 'TestThresholdHr' }, { key: 'TestMaxHr' }],
  // 跑步机
  Indoor_Run: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'FPRatio' },
    { key: 'AvgCadence' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' },
    { key: 'AvgGrade' }
  ],
  // 越野跑
  Trail_Run: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'FPRatio' },
    { key: 'AvgCadence' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Adjusted_Pace' },
    { key: 'Body_Temperature' }
  ],
  // 操场跑圈
  Track_Run: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'FPRatio' },
    { key: 'AvgCadence' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 徒步
  Hike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 登山
  Mtn_Climb: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'Bestkm' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 骑行
  Bike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 头盔骑行
  Helmet_Bike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 室内骑行
  Indoor_Bike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 公路 e-bike
  Road_Ebike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 砾石路骑行
  Gravel_Road_Bike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 山地骑行
  Mountain_Riding: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 山地 e-bike
  Mountain_Ebike: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'NP' },
    { key: 'Bike_IF' },
    { key: 'BikeLeftRightBalance' },
    { key: 'LeftRightTorqueEffectiveness' },
    { key: 'LeftRightPedalSmoothness' },
    { key: 'SeatedTime' },
    { key: 'StandingTime' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 泳池游泳
  Pool_Swim: [
    { key: 'Distance' },
    { key: 'Lengths' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'BestLen' },
    { key: 'AverageStroke' },
    { key: 'AvgStrkRate' },
    { key: 'AvgHR' },
    { key: 'SWOLF' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Water_Temperature' },
    { key: 'Body_Temperature' }
  ],
  // 公开水域
  Open_Water: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Water_Temperature' },
    { key: 'Body_Temperature' }
  ],
  // 铁三
  Triathlon: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 健身
  Strength: [
    { key: 'Sets' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 室内有氧
  Gym_Cardio: [
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 户外有氧
  GPS_Cardio: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 雪场双板
  Ski: [
    { key: 'DownhillDist' },
    { key: 'Lengths' },
    { key: 'DownhillTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'BestLen' },
    { key: 'DownhillDesc' },
    { key: 'MaxGrade' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 雪场单板
  Snowboard: [
    { key: 'DownhillDist' },
    { key: 'Lengths' },
    { key: 'DownhillTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'BestLen' },
    { key: 'DownhillDesc' },
    { key: 'MaxGrade' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 越野滑雪
  XC_Ski: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Adjusted_Speed' },
    { key: 'Body_Temperature' }
  ],
  // 登山滑雪
  Ski_Touring: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Adjusted_Speed' },
    { key: 'Body_Temperature' }
  ],
  // 登山滑雪（旧）
  Ski_Touring_Old: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 组合运动
  Multi_Sport: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 竞速帆板
  Speedsurfing: [
    { key: 'Max2s' },
    { key: 'Avg5x10s' },
    { key: 'TotalRunsDistance' },
    { key: 'Runs' },
    { key: 'TotalRunsTime' },
    { key: 'Fastest100m' },
    { key: 'Fastest250m' },
    { key: 'Fastest500m' },
    { key: 'Fastest1852m' },
    { key: 'Alpha500' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 帆板
  Windsurfing: [{ key: 'Distance' }, { key: 'WorkoutTime' }, { key: 'AvgSpeed' }, { key: 'Calories' }, { key: 'Body_Temperature' }],
  // 赛艇
  Row: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'AvgPace' },
    { key: 'Best500m' },
    { key: 'AvgHR' },
    { key: 'AvgPaddleRate' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 划船机
  Indoor_Row: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'AvgPace' },
    { key: 'Best500m' },
    { key: 'AvgHR' },
    { key: 'AvgPower' },
    { key: 'AvgPaddleRate' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 激流运动
  Whitewater: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'AvgSpeed' },
    { key: 'Best500m' },
    { key: 'AvgPaddleRate' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 静水运动
  Flatwater: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'AvgSpeed' },
    { key: 'Best500m' },
    { key: 'AvgHR' },
    { key: 'AvgPaddleRate' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 多段攀登
  Multi_Pitch: [
    { key: 'Distance' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 攀登
  Climb: [
    { key: 'Distance' },
    { key: 'Pitches' },
    { key: 'WorkoutTime' },
    { key: 'Vert_Speed' },
    { key: 'Hardest_Grade' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 健走
  Walk: [
    { key: 'Distance' },
    { key: 'Steps' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgPace' },
    { key: 'AvgHR' },
    { key: 'AvgCadence' },
    { key: 'ElevGain' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],
  // 跳绳
  Jump_Rope: [
    { key: 'Reps' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgSpeed' },
    { key: 'MaxSpeed' },
    { key: 'Max_Cont_Jumps' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ],

  // 室内攀岩 sportType: 800
  IndoorClimb: [
    { key: 'Routes' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'Hardest_Grade' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' },

    { key: 'Falls' },
    { key: 'ClimbingTime' },
    { key: 'MaxActivityFall' },
    { key: 'TotalAscent' }
  ],
  // 抱石 sportType: 801
  Bouldering: [
    { key: 'Routes' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'Hardest_Grade' },
    { key: 'AvgHR' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' },

    { key: 'TotalAscent' }
  ],
  // 爬楼 sportType: 902
  Climb_Stairs: [
    { key: 'Climb_Stairs_Floors' },
    { key: 'WorkoutTime' },
    { key: 'TotalTime' },
    { key: 'AvgHR' },
    { key: 'ElevGain' },
    { key: 'TotalDescent' },
    { key: 'TrainingLoad' },
    { key: 'Calories' },
    { key: 'Body_Temperature' }
  ]
};

// 保存自定义运动概要与dataType 的对应关系
export const CustomSummary = [
  {
    dataType: 0,
    keys: []
  },
  {
    dataType: 1,
    keys: []
  },
  {
    dataType: 2,
    keys: []
  },
  {
    dataType: 3,
    keys: ['Distance']
  },
  {
    dataType: 5,
    keys: ['Steps']
  },
  {
    dataType: 12,
    keys: ['WorkoutTime', 'TotalTime']
  },
  {
    dataType: 9,
    keys: ['AvgSpeed'] // 速度
  },
  {
    dataType: 10,
    keys: ['AvgPace'] // 配速
  },
  {
    dataType: 12,
    keys: ['AvgHR']
  },
  {
    dataType: 6,
    dsMultiplex: 10,
    keys: ['AvgCadence'] // 步频
  },
  {
    dataType: 6,
    dsMultiplex: 11,
    keys: []
  },
  {
    dataType: 6,
    dsMultiplex: 12,
    keys: ['AvgPaddleRate'] // 浆频
  },
  {
    dataType: 6,
    dsMultiplex: 13,
    keys: []
  },
  {
    dataType: 4,
    keys: ['ElevGain', 'TotalDescent']
  },
  {
    dataType: 12,
    keys: ['TrainingLoad', 'Calories']
  },
  {
    dataType: 7,
    dsMultiplex: 20,
    keys: []
  },
  {
    dataType: 7,
    dsMultiplex: 21,
    keys: []
  },
  {
    dataType: 7,
    dsMultiplex: 22,
    keys: []
  },
  {
    dataType: 11,
    keys: []
  },
  {
    dataType: 13,
    keys: ['Adjusted_Pace']
  },
  {
    dataType: 14,
    keys: []
  }
];

export const CustomChart = [
  {
    dataType: 0,
    chartName: []
  },
  {
    dataType: 1,
    chartName: []
  },
  {
    dataType: 2,
    chartName: []
  },
  {
    dataType: 3,
    chartName: []
  },
  {
    dataType: 10,
    chartName: ['Pace'] // 配速
  },
  {
    dataType: 9,
    chartName: ['Speed'] // 速度
  },
  {
    dataType: 6,
    dsMultiplex: 10,
    chartName: ['Step_Cadence'] // 步频
  },
  {
    dataType: 6,
    dsMultiplex: 11,
    chartName: []
  },
  {
    dataType: 6,
    dsMultiplex: 12,
    chartName: ['Row_Stroke_Rate'] // 浆频
  },
  {
    dataType: 6,
    dsMultiplex: 13,
    chartName: []
  },
  {
    dataType: 7,
    dsMultiplex: 20,
    chartName: ['Stride_Length'] // 步幅
  },
  {
    dataType: 7,
    dsMultiplex: 21,
    chartName: ['Stroke_Length'] // 滑距
  },
  {
    dataType: 7,
    dsMultiplex: 22,
    chartName: []
  },
  {
    dataType: 8,
    chartName: []
  },
  {
    dataType: 4,
    chartName: ['Elevation']
  },
  {
    dataType: 5,
    chartName: []
  },
  {
    dataType: 11,
    chartName: []
  },
  {
    dataType: 12,
    chartName: ['Heart_Rate']
  },
  {
    dataType: 13,
    chartName: []
  }
];
export const CustomLap = [
  {
    dataType: 0,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 1,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 2,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 12,
    keys: ['Laps_Lengths'], // 圈数
    config: { status: true }
  },
  {
    dataType: 3,
    keys: ['Distance'],
    config: { status: true }
  },
  {
    dataType: 5,
    keys: ['Steps'],
    config: { status: true }
  },
  {
    dataType: 12,
    keys: ['Time'], // 时间
    config: { status: true }
  },
  {
    dataType: 12,
    keys: ['Total_Length'], // 总时间
    config: { status: true }
  },
  {
    dataType: 10,
    keys: ['Avg_Pace'],
    config: { status: true }
  },
  {
    dataType: 9,
    keys: ['Avg_Speed'],
    config: { status: true }
  },
  {
    dataType: 12,
    keys: ['Avg_HR', 'Max_HR'], // 平均心率, 最大心率
    config: { status: true }
  },
  {
    dataType: 6,
    dsMultiplex: 10,
    keys: ['Avg_Step_Cadence', 'Max_Cadence'], // 步频
    config: { status: true }
  },
  {
    dataType: 6,
    dsMultiplex: 11,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 6,
    dsMultiplex: 12,
    keys: ['Row_Stroke_Rate'], // 浆频
    config: { status: true }
  },
  {
    dataType: 6,
    dsMultiplex: 13,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 7,
    dsMultiplex: 20,
    keys: ['Avg_Stride_Length'], // 步幅
    config: { status: true }
  },
  {
    dataType: 7,
    dsMultiplex: 21,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 7,
    dsMultiplex: 22,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 8,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 4,
    keys: ['Elev_Gain', 'Total_Descent'],
    config: { status: true }
  },

  {
    dataType: 11,
    keys: [],
    config: { status: true }
  },
  {
    dataType: 12,
    keys: ['Calories'], // 卡路里
    config: { status: true }
  },
  {
    dataType: 13,
    keys: ['Adjusted_Pace'],
    config: { status: true }
  }
];

// 对外提供自定义运动概要的key map
export const customSummaryKeyMap = {};
CustomSummary.forEach((item, index) => {
  const { dataType, keys, dsMultiplex } = item;
  if (!customSummaryKeyMap[dataType]) {
    customSummaryKeyMap[dataType] = [];
  }
  customSummaryKeyMap[dataType].push({
    keys,
    order: index,
    dataType,
    dsMultiplex
  });
});
// 对外提供自定义运动chart的key map
export const customChartKeyMap = {};
CustomChart.forEach((item, index) => {
  const { dataType, chartName, dsMultiplex } = item;
  if (!customChartKeyMap[dataType]) customChartKeyMap[dataType] = [];
  customChartKeyMap[dataType].push({
    order: index,
    chartName,
    dataType,
    dsMultiplex
  });
});
// 对外提供自定义运动圈数据的key map
export const customLapKeyMap = {};
CustomLap.forEach((item, index) => {
  const { dataType, dsMultiplex } = item;
  if (!customLapKeyMap[dataType]) customLapKeyMap[dataType] = [];
  customLapKeyMap[dataType].push({
    ...item,
    order: index,
    dsMultiplex
  });
});
